"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentEnvSpecs = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access */
var config_1 = __importDefault(require("../config"));
function getDeviceSpecs() {
    var _a, _b, _c, _d;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var navigator = window.navigator;
    return {
        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
        platform: navigator === null || navigator === void 0 ? void 0 : navigator.platform,
        connection: {
            downlink: (_a = navigator === null || navigator === void 0 ? void 0 : navigator.connection) === null || _a === void 0 ? void 0 : _a.downlink,
            effectiveType: (_b = navigator === null || navigator === void 0 ? void 0 : navigator.connection) === null || _b === void 0 ? void 0 : _b.effectiveType,
            type: (_c = navigator === null || navigator === void 0 ? void 0 : navigator.connection) === null || _c === void 0 ? void 0 : _c.type,
            rtt: (_d = navigator === null || navigator === void 0 ? void 0 : navigator.connection) === null || _d === void 0 ? void 0 : _d.rtt,
        },
        appVersion: navigator === null || navigator === void 0 ? void 0 : navigator.appVersion,
    };
}
function getCurrentEnvSpecs() {
    return __assign(__assign({}, getDeviceSpecs()), { packages: config_1.default.packageVersions });
}
exports.getCurrentEnvSpecs = getCurrentEnvSpecs;
//# sourceMappingURL=utils.js.map